export const SOUNDBOARD_COLLECTION = 'soundboard';
export const SOUND_CLIP_COLLECTION = 'sound-clips';
export const SOUND_CLIP_RATINGS_COLLECTION = 'ratings';
